import StepId from "@/model/progress/StepId"
import StartView from "@/views/StartView.vue"

export default [
    {
        name: "startWithDefaultEntityKey",
        path: "/start",
        component: StartView,
        meta: {
            public: true,
            step: StepId.PATIENT_INFO,
        },
    },
    {
        name: "startWithEntityKey",
        path: "/start/entity-keys/:entityKey",
        component: StartView,
        meta: {
            public: true,
            step: StepId.PATIENT_INFO,
        },
    },
    {
        name: "startWithToken",
        path: "/start/tokens/:token",
        component: StartView,
        meta: {
            public: true,
            step: StepId.PATIENT_INFO,
        },
    },
]
